export const getLabelByKey = (key, componentValue) => {
  if (key) {
    const data = componentValue.filter(
      v => v && v.value && v.value.toUpperCase() === key.toUpperCase()
    );
    return data && data.length > 0 ? data[0].label : '';
  }
  return '';
};
